import { render, staticRenderFns } from "./UpgradeConfirmation.vue?vue&type=template&id=83901360&scoped=true&"
import script from "./UpgradeConfirmation.vue?vue&type=script&lang=js&"
export * from "./UpgradeConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeConfirmation.vue?vue&type=style&index=0&id=83901360&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83901360",
  null
  
)

export default component.exports